import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "../ui/Button.jsx";
import { cn } from "../../lib/cn.js";

/**
 * Compact paginator for DataTable. Pass the meta object from the paginated
 * API response: { page, limit, total, totalPages, hasNext, hasPrev }.
 */
export function Pagination({ meta, onChange, className }) {
  if (!meta || meta.totalPages <= 1) return null;
  const { page, totalPages, total, limit, hasNext, hasPrev } = meta;
  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  return (
    <div
      className={cn(
        "flex items-center justify-between border-t border-border-subtle bg-bg-elevated px-4 py-3 text-xs text-text-muted",
        className
      )}
    >
      <div>
        Showing <span className="font-medium text-text-primary">{start}</span>–
        <span className="font-medium text-text-primary">{end}</span> of{" "}
        <span className="font-medium text-text-primary">{total}</span>
      </div>
      <div className="flex items-center gap-1">
        <Button variant="ghost" size="sm" disabled={!hasPrev} onClick={() => onChange(page - 1)}>
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <span className="px-2 text-text-secondary">
          Page <span className="font-medium text-text-primary">{page}</span> of {totalPages}
        </span>
        <Button variant="ghost" size="sm" disabled={!hasNext} onClick={() => onChange(page + 1)}>
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
